import { render, staticRenderFns } from "./MenuTabsMobile.vue?vue&type=template&id=41a17ed8&"
import script from "./MenuTabsMobile.vue?vue&type=script&lang=js&"
export * from "./MenuTabsMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports